import {initSplideSlider} from "../../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Plugins/SplideSlider";
import PageLoadedQueue from "../../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";

const profileSlider = () => {
    const profilesSliderElements = document.querySelectorAll('.experts-profile-slider') as NodeListOf<HTMLElement>;

    profilesSliderElements.forEach(profileSliderElement => {
        const slider = initSplideSlider(profileSliderElement, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            gap: 20,
            pagination: false,
            arrows: true,
            drag: true,
            snap: true,
            autoplay: false,
            interval: 2000,
            pauseOnHover: true,
            lazyLoad: 'nearby',
            mediaQuery: 'min',
            breakpoints: {
                1201: {
                    perPage: 3,
                },
                993: {
                    perPage: 2,
                },
                769: {
                    perPage: 2,
                },
                576: {
                    perPage: 1,
                },
                400: {
                    perPage: 1,
                },
            },
            padding: { left: 0, right: 50 }
        })
    });
}

PageLoadedQueue.addFunction(profileSlider);
